
import { mobileMoneyProviders } from '@/domains/landing-page/mock/data';

interface MobileMoneyModalProps {
    showMobileMoney: boolean;
    setShowMobileMoney: (show: boolean) => void;
}

export default function MobileMoneyModal({ showMobileMoney, setShowMobileMoney }: MobileMoneyModalProps) {
    if (!showMobileMoney) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl max-w-2xl w-full">
          <div className="p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Solutions Mobile Money</h3>
              <button
                onClick={() => setShowMobileMoney(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <p className="text-gray-600 mb-8">
              Payez vos livraisons directement depuis votre téléphone avec les solutions
              Mobile Money les plus populaires en Afrique.
            </p>

            <div className="grid md:grid-cols-2 gap-4">
              {mobileMoneyProviders.map((provider) => (
                <div key={provider.id} className="border rounded-xl p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center">
                    <div className={`w-12 h-12 ${provider.color} rounded-lg flex items-center justify-center mr-4`}>
                      <i className={`${provider.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{provider.name}</h4>
                      <div className="flex flex-wrap gap-1 mt-2">
                        {provider.countries.map((country) => (
                          <span key={country} className="text-xs bg-gray-100 px-2 py-1 rounded">
                            {country}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => setShowMobileMoney(false)}
              className="mt-8 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors w-full"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    )
}
